import React from "react";
import { useIsDesktopViewport } from "../../../hooks/useIsDesktopViewport";
import { DesktopBackLink } from "../../navigation/ScreenBackButton";
import "../adminDesktop.css";

function toTitleCase(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function AdminFormCard({ title, children, className = "" }) {
  return (
    <div className={`rb-card ${className}`.trim()}>
      {title ? <div className="section-heading">{title}</div> : null}
      {children}
    </div>
  );
}

export function AdminListRow({ children, onClick }) {
  return (
    <div
      className="profile-value"
      style={onClick ? { cursor: "pointer", marginBottom: "10px" } : { marginBottom: "10px" }}
      onClick={onClick}
      onKeyDown={
        onClick
          ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                onClick(event);
              }
            }
          : undefined
      }
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {children}
    </div>
  );
}

export function AdminLegacyHeader({ title, onBack, backLabel = "Users" }) {
  const isDesktop = useIsDesktopViewport();
  if (isDesktop) {
    return (
      <div className="adm-pagehead">
        {onBack ? <DesktopBackLink onClick={onBack} label={backLabel} /> : null}
        <h1 className="cp-module-title adm-pagehead__title">{toTitleCase(title)}</h1>
      </div>
    );
  }
  return (
    <div className="cockpit-header">
      <button type="button" className="cockpit-back-btn" onClick={onBack}>
        Back
      </button>
      <div>
        <div className="cockpit-title">{title}</div>
      </div>
    </div>
  );
}
